import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { Toaster } from '../ui/sonner';
import { MarketingPopup } from '../MarketingPopup';
import { BlueWaveBar } from '../BlueWave';

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/+$/, '');

export const MarketingLayout = () => {
  const { pathname } = useLocation();
  const [blueWaveEnabled, setBlueWaveEnabled] = useState(false);
  const [blueWaveDismissed, setBlueWaveDismissed] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    fetch(`${BACKEND_URL}/api/settings`)
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (d) setBlueWaveEnabled(d.blue_wave_enabled || false); })
      .catch(() => {});
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      {blueWaveEnabled && !blueWaveDismissed && (
        <div className="relative z-[60]">
          <BlueWaveBar onClose={() => setBlueWaveDismissed(true)} />
        </div>
      )}
      {!blueWaveEnabled && <Navbar blueWaveEnabled={false} />}
      {blueWaveEnabled && pathname !== '/' && <Navbar blueWaveEnabled={false} />}
      <main className={`flex-1 ${pathname === '/' ? 'pt-0' : 'pt-24'}`}>
        <Outlet context={{ blueWaveEnabled }} />
      </main>
      <Footer />
      <Toaster position="top-right" richColors />
      <MarketingPopup />
    </div>
  );
};

export default MarketingLayout;
